import { NodeConnection, RouteChildNodeDataType, RouteNodeType } from '@lp/features/RoutePlanner/types';
import { SegmentTypeEnum } from '@/api/apis/route';

export const getChildTargetHandleType = (
  toNode: RouteNodeType | RouteNodeType<RouteChildNodeDataType>,
  connectionType: 'from' | 'to',
  index: number,
) => {
  const isTo = connectionType === 'to';
  const isMainSegments = [SegmentTypeEnum.hospital, SegmentTypeEnum.txcenter, SegmentTypeEnum.hub].includes(
    toNode.data.segmentType,
  );

  switch (index) {
    case 1:
      if (isTo && isMainSegments) {
        return NodeConnection.toRight;
      }

      return NodeConnection.toMainLeft;
    case 2:
      if (isTo && isMainSegments) {
        return NodeConnection.toCenter;
      }

      return NodeConnection.toCenter;
    default:
      if (isTo && isMainSegments) {
        return NodeConnection.toLeft;
      }

      return NodeConnection.toMainRight;
  }
};

export const getChildSourceHandleType = (
  fromNode: RouteNodeType | RouteNodeType<RouteChildNodeDataType>,
  connectionType: 'from' | 'to',
  index: number,
) => {
  const isFrom = connectionType === 'from';
  const isMainSegments = [SegmentTypeEnum.hospital, SegmentTypeEnum.txcenter, SegmentTypeEnum.hub].includes(
    fromNode.data.segmentType,
  );

  switch (index) {
    case 1:
      if (isFrom && isMainSegments) {
        return NodeConnection.fromRight;
      }

      return NodeConnection.fromMainLeft;
    case 2:
      if (isFrom && isMainSegments) {
        return NodeConnection.fromCenter;
      }

      return NodeConnection.fromCenter;
    default:
      if (isFrom && isMainSegments) {
        return NodeConnection.fromLeft;
      }

      return NodeConnection.fromMainRight;
  }
};
